import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'CommodityEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      commodityEditItem: null,
      mode: 'edit'
    }
  },

  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.commodityEditItem = {
        description: null,
        price: null,
        defaultProduction: 180
      }
    } else {
      this.mode = 'edit'
      let item = this.$store.getters.getCommodityItemById(this.id)
      // just want a local copy for the form
      this.commodityEditItem = {...item}
    }
  },

  methods: {
    submitForm (evt) {
      evt.preventDefault()
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/commodities'

      jsConn.formParams = {
        id: this.id,
        item: this.commodityEditItem
      }
      this.$store.dispatch('updateCommodityItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
